import dayjs from "dayjs";

// here keep all app constans
export const APP_STAGE = {
    LOCAL: "local",
    DEVEL: "devel",
    STAGE: "stage",
    PREPROD: "preprod",
    PROD: "prod",
};

export const LANGUAGE_KEY_IN_LOCAL_STORAGE = "language";
export const FILTER_SEPARATOR = "^";
export const FORMAT_NUMBER_SEPARATOR = " ";
export const APP_STAGE_BAR_HEIGHT = "22px";
export const DEFAULT_TEXT_FIELD_MAX_LENGTH = "256";
export const DEFAULT_MULTILINE_TEXT_FIELD_MAX_LENGTH = "1024";

export const TEXT_FIELD_TYPE = "text";
export const NUMERIC_FIELD_TYPE = "numeric";
export const INTEGER_FIELD_TYPE = "integer";
export const CHECKBOX_FIELD_TYPE = "checkbox";
export const SELECT_FIELD_TYPE = "select";
export const AUTOCOMPLETE_FIELD_TYPE = "autocomplete";
export const BOOLEAN_FIELD_TYPE = "boolean";
export const DATE_FIELD_TYPE = "date";
export const DATETIME_TO_DATE_FIELD_TYPE = "datetime_to_date";
export const DATE_TO_DATETIME_FIELD_TYPE = "date_to_datetime";
export const DATE_RANGE_FIELD_TYPE = "date_range";
export const DATETIME_TO_DATE_RANGE_FIELD_TYPE = "datetime_to_date_range";
export const DATETIME_TO_DATE_RANGE_START_FIELD_SUBTYPE = "datetime_to_date_range_start";
export const DATETIME_TO_DATE_RANGE_END_FIELD_SUBTYPE = "datetime_to_date_range_end";
export const INTEGER_RANGE_FIELD_TYPE = "integer_range";
export const NUMERIC_RANGE_FIELD_TYPE = "numeric_range";
export const BUTTON_FIELD_TYPE = "button_type";
export const DATE_TIME_FIELD_TYPE = "datetime";
export const DATE_TIME_RANGE_FIELD_TYPE = "datetime_range";
export const TIME_FIELD_TYPE = "time";
export const TIME_RANGE_FIELD_TYPE = "time_range";

export const TABLE_TEXT_FIELD_MAX_LENGTH = "64";
export const TABLE_TEXT_FIELD_MAX_EXTEND_LENGTH = "256";

export const ORDERING_DIRECTION_ASC = "asc";
export const ORDERING_DIRECTION_DESC = "desc";

export const SELECTED_ROW_COLOR = "var(--selected-row)";
export const FAVORITE_ROW_COLOR = "var(--favorite)";
export const CLOSED_ROW_COLOR = "var(--closed)";
export const NOT_CONNECTED_ROW_COLOR = "var(--not-connected)";
export const NEW_LEAD_COLOR = "var(--new-lead)";

export const PAGINATION_PAGE_SIZE = 10;
export const BIG_PAGINATION_PAGE_SIZE = 100;

export const EDIT_PERMISSION = "edit";

export const COMPANY_LEGAL_TYPES = ["Sp. z.o.o.", "SA", "sp. k.", "Other"];
export const COMPANY_ROLE_CHOICES = [
    "Owner",
    "Director",
    "Management Board Member",
    "Proxy",
    "Complementary",
    "Comanditary",
    "President",
    "Secretary",
    "Employee",
];

export const FORM_ERR = {
    person_name_required: "person_name_required",
    name_required: "name_required",
    surname_required: "surname_required",
    email_required: "email_required",
    email_incorrect: "email_incorrect",
    company_legal_type_required: "company_legal_type_required",
    company_short_name_required: "company_short_name_required",
};

export const MIN_WORK_HOUR = 8;
export const MIN_WORK_MINUTE = 0;
export const MAX_WORK_HOUR = 19;
export const MAX_WORK_MINUTE = 0;

export const MIN_WORK_TIME = MIN_WORK_HOUR * 60 + MIN_WORK_MINUTE;
export const MAX_WORK_TIME = MAX_WORK_HOUR * 60 + MAX_WORK_MINUTE;

export const MINUTES_TO_MILLISECONDS = 60000;
export const DEFAULT_TASK_DURATION_IN_MINUTES = 15;
export const DEFAULT_TASK_DURATION_FOR_MEETING_IN_MINUTES = 90;

export const MIN_WORK_TIME_DAYJS = dayjs(
    `2000-01-01T${String(MIN_WORK_HOUR).padStart(2, "0")}:${String(MIN_WORK_MINUTE).padStart(2, "0")}`,
);
export const MAX_WORK_TIME_DAYJS = dayjs(
    `2000-01-01T${String(MAX_WORK_HOUR).padStart(2, "0")}:${String(MAX_WORK_MINUTE).padStart(2, "0")}`,
);

export const MIN_WORK_TIME_STRING = `${String(MIN_WORK_HOUR).padStart(2, "0")}:${String(MIN_WORK_MINUTE).padStart(2, "0")}:00`;
export const MAX_WORK_TIME_STRING = `${String(MAX_WORK_HOUR).padStart(2, "0")}:${String(MAX_WORK_MINUTE).padStart(2, "0")}:00`;
export const MAX_WORK_TIME_IN_CALENDAR_STRING = `${String(MAX_WORK_HOUR + 1).padStart(2, "0")}:${String(MAX_WORK_MINUTE).padStart(2, "0")}:00`;

export const DOCS_RESTRICTED_USER = "docs_restricted_user";
export const DOCS_RESTRICTED_ROLE = "docs_restricted_role";
export const MAX_FILENAME_LENGTH_CHARS = 200;
export const MAX_ALLOWED_ENCLOSURE_SIZE_IN_BYTES = 52428800;
export const MAX_ALLOWED_FILE_SIZE_IN_MB = MAX_ALLOWED_ENCLOSURE_SIZE_IN_BYTES / 1048576;

export const PRODUCT_STATUS = {
    DEFAULT: "Available",
    NONE: "None",
};

export const USER_ROLES = {
    ADMIN: "is_admin",
    SALES: "is_sales",
    SALES_MANAGER: "is_sales_manager",
    SALES_LEGAL: "is_sales_legal",
    SALES_MARKETING: "is_sales_marketing",
    INVESTMENT_DPI: "is_investment_dpi",
    ACCOUNT: "is_account"
};

export const externalLeadSources = [
    "www",
    "landing_page_form",
    "phone",
    "recommendation",
    "broker",
    "obido",
    "morizon",
    "tabelaofert",
    "rynekpierwotny",
    "facebook",
    "google_ads",
];

export const MAX_PERCENTAGE_DECIMAL_PLACES = 10;

export const ERROR_TEXT_STYLE = {
  marginLeft: 0,
  marginRight: 0,
  fontWeight: "bold",
  color: "red",
  minWidth: "180px",
};

export const UNIQUE_ERROR_TEXT = {
  helperText: "field should be unique",
  helperTextStyle: ERROR_TEXT_STYLE,
};

export const ALERT_ROW_COLOR = "var(--red-light)";
export const SUCCES_ROW_COLOR = "var(--green-light)";

export const MAX_NUMBER_OF_INSTANCES_TO_EXPORT_TO_FILE = 1000

export const PROUDCT_STATUS_AVAILABLE_ID = 'd236017a-6e72-44db-b456-6507a64d1573'
export const PROUDCT_STATUS_FICTIONAL_RESERVATION_ID = 'd8a947fe-a6ba-4f07-a07a-3ed9b8c7a79c'


export const CLAUSE_TAG = {
    RODO: "RODO",
    MARKETING: "Marketing",
};

export const ALPHABET = "abcdefghijklmnopqrstuvwxyz";
export const UPPERCASE_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";